module.exports = __webpack_public_path__ + "7aeb4d857c0dbdcac4432b07c0bde9c4.ttf";


//////////////////
// WEBPACK FOOTER
// ./assets/Lato-Semibold.ttf
// module id = 981
// module chunks = 0